export const CALLING_JS_API_ERROR = 'CALLING_JS_API_ERROR';